import { AxisZRotateCounterclockwiseIcon } from './AxisZRotateCounterclockwiseIcon';

/**
 * author: Michael Irigoyen
 * id DB0819A2-5E99-483B-BBC8-AEAD0DE9D196
 * name axis-z-rotate-counterclockwise
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/axis-z-rotate-counterclockwise.svg
 * tags
 */
export const VerticalRotateCounterclockwiseIcon = AxisZRotateCounterclockwiseIcon;
export default VerticalRotateCounterclockwiseIcon